"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutMainContentTabMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const tabview_1 = require("primereact/tabview");
const LayoutMainContentTabMenu = (props) => {
    const ref = (0, react_1.useRef)(null);
    const [activeIndex, setActiveIndex] = (0, react_1.useState)(props.activeIndex ? props.activeIndex : 0);
    const [height, setHeight] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        if (ref && ref.current) {
            //@ts-ignore
            setHeight(ref.current.clientHeight);
        }
    });
    (0, react_1.useEffect)(() => {
        _setActiveIndex();
    }, []);
    (0, react_1.useEffect)(() => {
        _setActiveIndex();
    }, [window.location.hash]);
    (0, react_1.useEffect)(() => {
        _setActiveIndex();
    }, [props.items]);
    const _setActiveIndex = () => {
        if (window.location.hash.indexOf('_') > -1) {
            const index = window.location.hash.substring(window.location.hash.indexOf('_') + 1, window.location.hash.length);
            if (!isNaN(Number(index)) && Number(index) <= props.items.length)
                setActiveIndex(Number(index));
            else {
                props.items.forEach((obj, i) => {
                    if (obj.id === index)
                        setActiveIndex(Number(i));
                });
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "card", ref: ref }, { children: [(0, jsx_runtime_1.jsx)(tabview_1.TabView
                    // model={props.items}
                    , Object.assign({ 
                        // model={props.items}
                        activeIndex: activeIndex, 
                        // scrollable
                        onTabChange: (e) => {
                            setActiveIndex(e.index);
                            if (window.location.hash.indexOf('_') > -1) {
                                window.location.hash = window.location.hash.substring(0, window.location.hash.indexOf('_')) + '_' + e.index;
                            }
                            else {
                                window.location.hash = window.location.hash + '_' + e.index;
                            }
                            if (props.onTabChange)
                                props.onTabChange(e);
                        } }, { children: props.items.map((item) => {
                            if (item.visible !== false) {
                                return ((0, jsx_runtime_1.jsx)(tabview_1.TabPanel, { header: item.icon ?
                                        (0, jsx_runtime_1.jsxs)("span", { children: [item.icon, item.label] }) : item.label }, item.id));
                            }
                        }) })), props.items.length > 0 && activeIndex > -1 && props.items[activeIndex] && props.items[activeIndex].buttons] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'scroll-card-main-content md:absolute' + (props.showCard === false ? '' : ' card'), style: { 'top': (height + 28) + 'px' } }, { children: (props.items.length > 0 && activeIndex > -1) && props.items[activeIndex] && props.items[activeIndex].component }))] }));
};
exports.LayoutMainContentTabMenu = LayoutMainContentTabMenu;
